import { render } from "./FeedbackView.vue?vue&type=template&id=24689937&scoped=true"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"

import "./FeedbackView.vue?vue&type=style&index=0&id=24689937&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24689937"]])

export default __exports__